import { Fraction } from 'bi-fraction';
import { ConvertibleToShare as ConvertibleToShareAbi, ConvertibleToShares as ConvertibleToSharesAbi, Curve3Pool as Curve3PoolAbi, ERC20 as ERC20Abi, PrelaunchDeposit as PrelaunchDepositAbi, WCRO as WCROAbi, YbETHL1 as YbETHL1Abi, YbETHNft as YbETHNftAbi, YbUSDL1 as YbUSDL1Abi, Zkcro as ZkcroAbi, } from './abis';
import { BridgeMiddleware } from './contracts/bridgeMiddleware';
import { PrelaunchDepositEthereum } from './contracts/prelaunchDepositEthereum';
import { WcroOnEthereum } from './contracts/wcroOnEtherum';
import { YbTokenBridge } from './contracts/ybTokenBridge';
import { ZkCroMintAndBridge } from './contracts/zkCroMintAndBridge';
import { ZkCroToZkCroDepositor } from './contracts/zkCroToZkCroDepositor';
import { ChainLayer } from './types';
import { getContract, getProvider } from './utils';
export class SDK_L1 {
    constructor(providerOptions, contractAddressMap) {
        this.providerOptions = providerOptions;
        this.contractAddressMap = contractAddressMap;
        this.getContract = (address, abi, signerOrProvider) => {
            if (!signerOrProvider) {
                signerOrProvider = getProvider(this.providerOptions, ChainLayer.L1);
            }
            return getContract(address, abi, signerOrProvider);
        };
        this.getContractAddress = (contractName) => {
            return this.contractAddressMap[contractName];
        };
        this.getERC20 = (address, signerOrProvider) => this.getContract(address, ERC20Abi, signerOrProvider);
        this.getConvertibleToShare = (address) => this.getContract(address, ConvertibleToShareAbi);
        this.getConvertibleToShares = (address) => this.getContract(address, ConvertibleToSharesAbi);
        this.getWCRO = (signerOrProvider) => {
            const contract = this.getWCROContract(signerOrProvider);
            return new WcroOnEthereum(contract);
        };
        this.getPrelaunchDeposit = (signerOrProvider) => new PrelaunchDepositEthereum(this.getContract(this.getContractAddress('PrelaunchDeposit'), PrelaunchDepositAbi, signerOrProvider), this.getWCROContract(signerOrProvider), this.providerOptions);
        this.getBridgeMiddleware = (signerOrProvider, l2providerOptions) => new BridgeMiddleware({
            l1providerOptions: this.providerOptions,
            l2providerOptions,
            signerOrProvider,
            contractAddressMap: this.contractAddressMap,
        });
        this.getYbTokenBridge = (options) => {
            return new YbTokenBridge({
                ...options,
                contractAddressMap: this.contractAddressMap,
                l1ProviderOptions: this.providerOptions,
            });
        };
        this.getZkCroMintAndBridge = (options) => {
            return new ZkCroMintAndBridge({
                ...options,
                contractAddressMap: this.contractAddressMap,
                l1ProviderOptions: this.providerOptions,
            });
        };
        this.getZkCroDepositor = (options) => {
            return new ZkCroToZkCroDepositor({
                ...options,
                contractAddressMap: this.contractAddressMap,
                l1ProviderOptions: this.providerOptions,
            });
        };
        this.getNativeTokenBalance = async (address) => {
            const provider = getProvider(this.providerOptions, ChainLayer.L1);
            const balance = await provider.getBalance(address);
            return new Fraction(balance).shr(18);
        };
        this.getWCROContract = (signerOrProvider) => this.getContract(this.getContractAddress('WCRO'), WCROAbi, signerOrProvider);
        this.getZkCroContract = (signerOrProvider) => this.getContract(this.getContractAddress('ZkCRO'), ZkcroAbi, signerOrProvider);
        this.getYbUsdContract = (signerOrProvider) => this.getContract(this.getContractAddress('YbUSD'), YbUSDL1Abi, signerOrProvider);
        this.get3PoolContract = (signerOrProvider) => this.getContract(this.getContractAddress('Curve3Pool'), Curve3PoolAbi, signerOrProvider);
        this.getYbEthContract = (signerOrProvider) => this.getContract(this.getContractAddress('YbETH'), YbETHL1Abi, signerOrProvider);
        this.getYbEthNftContract = (signerOrProvider) => this.getContract(this.getContractAddress('YbETHNft'), YbETHNftAbi, signerOrProvider);
    }
    toJSON() {
        return JSON.stringify({
            chainId: this.providerOptions.chainId,
        });
    }
}
